export const categories = [
  {
    id: 6,
    order: 7,
    class: 'centers',
    title: 'ЦЕНТРЫ',
  },
  {
    id: 7,
    order: 8,
    class: 'inspections',
    title: 'ГОСУДАРСТВЕННЫЕ ИНСПЕКЦИИ',
  },
  {
    id: 8,
    order: 9,
    class: 'local-administrations',
    title: 'ОРГАНЫ ГОСУДАРСТВЕННОЙ ВЛАСТИ НА МЕСТАХ',
  },
  {
    id: 9,
    order: 11,
    class: 'associations',
    title: 'АССОЦИАЦИИ И КОНЦЕРНЫ',
  },
  {
    id: 10,
    order: 10,
    class: 'companies',
    title: 'КОМПАНИИ',
  },
  {
    id: 12,
    order: 15,
    class: 'others',
    title: 'ДРУГИЕ ВЕДОМСТВА, УЧРЕЖДЕНИЯ И ОРГАНИЗАЦИИ',
  },
  {
    id: 13,
    order: 12,
    class: 'banks',
    title: 'БАНКИ',
  },
  {
    id: 14,
    order: 13,
    class: 'foundations',
    title: 'СФЕРА ЗДРАВООХРАНЕНИЯ',
  },
  {
    id: 15,
    order: 1,
    class: 'committees',
    title: 'ПОДРАЗДЕЛЕНИЯ АДМИНИСТРАЦИИ',
  },
  {
    id: 16,
    order: 3,
    class: null,
    title: 'ПРАВООХРАНИТЕЛЬНЫЕ ОРГАНЫ',
  },
  {
    id: 11,
    order: 14,
    class: 'societies',
    title: 'СФЕРА ГОСУДАРСТВЕННОЙ СЛУЖБЫ И ТРУДОВЫХ ОТНОШЕНИЙ',
  },
  {
    id: 1,
    order: 2,
    class: 'organizations',
    title: 'ЦЕНТРАЛЬНЫЕ УЧРЕЖДЕНИЯ',
  },
  {
    id: 2,
    order: 3,
    class: 'ministries',
    title: 'МИНИСТЕРСТВА',
  },
  {
    id: 3,
    order: 4,
    class: 'state-committees',
    title: 'ГОСУДАРСТВЕННЫЕ КОМИТЕТЫ',
  },
  {
    id: 17,
    order: 2,
    class: null,
    title: 'НАРОДНЫЕ ПРИЕМНЫЕ',
  },
  {
    id: 4,
    order: 5,
    class: 'agencies',
    title: 'АГЕНТСТВА',
  },
  {
    id: 5,
    order: 6,
    class: 'jamorg',
    title: 'ОРГАНИЗАЦИИ ПРИ КАБИНЕТЕ МИНИСТРОВ',
  },
  {
    id: 18,
    order: 19,
    class: null,
    title: 'НЕГОСУДАРСТВЕННЫЕ НЕКОММЕРЧЕСКИЕ ОРГАНИЗАЦИИ',
  },
  {
    id: 19,
    order: 21,
    class: null,
    title: 'СФЕРА ИНФОРМАЦИИ И ИННОВАЦИЙ',
  },
  {
    id: 20,
    order: 22,
    class: null,
    title: 'СФЕРА ОБРАЗОВАНИЯ И НАУКИ',
  },
  {
    id: 21,
    order: 23,
    class: null,
    title: 'СОЦИАЛЬНАЯ СФЕРА',
  },
];

export const bodies = [
  { id: 1, title: ' Ўзбекистон Республикаси Иқтисодиёт Вазирлиги', order: 500 },
  {
    id: 3,
    title: 'Ўзбекистон Республикаси Молия вазирлиги',
    address: '100008, Тошкент шаҳри, Мустақиллик майдони, 5',
    // "phone":"0(371) 239-1252",
    website: 'www.mf.uz',
    email: 'info@mf.uz',
    fax: '0(371) 244-5643',
    category_id: 1,
    cabinetpm_org_id: 1,
    category_title: 'Вазирликлар',
    category_class: 'ministries',
    functions: '',
    tasks: '<ul><li>Bibibib</li></ul>',
    guid: '9feb4506-b7d4-ce82-29cc-2efe0b17303d',
    // "heads":[
    // 	{
    // 		"head_title":"Хўжаев Ботир Асадиллаевич",
    // 		"head_order":10,
    // 		"head_position":"Вазир",
    // 		"head_phone":"0(371) 233-1225",
    // 		"reception_days":"Жума",
    // 		"reception_time":"16:00 - 18:00",
    // 		"email":"Priyomnayamf@mf.uz"
    // 	}
    // ]
  },
  { id: 4, title: 'Ўзбекистон Республикаси Бандлик ва меҳнат муносабатлар вазирлиги', order: 500 },
  { id: 5, title: ' Ўзбекистон Республикаси Қишлоқ ва сув хўжалиги вазирлиги', order: 500 },
  { id: 6, title: 'Ўзбекистон Республикаси Олий ва ўрта махсус таълим вазирлиги', order: 500 },
  { id: 7, title: ' Ўзбекистон Республикаси Халқ таълими вазирлиги', order: 500 },
  { id: 8, title: 'Ўзбекистон Республикаси Соғлиқни сақлаш вазирлиги', order: 500 },
  { id: 9, title: ' Ўзбекистон Республикаси Маданият вазирлиги', order: 500 },
  { id: 10, title: ' Ўзбекистон Республикаси Мудофаа вазирлиги', order: 500 },
  { id: 11, title: 'Ўзбекистон Республикаси Ички ишлар вазирлиги', order: 500 },
  { id: 12, title: 'Ўзбекистон Республикаси Фавқулодда вазиятлар вазирлиги', order: 500 },
  { id: 13, title: ' Уй-жой коммунал хўжалиги вазирлиги', order: 500 },
  { id: 14, title: 'Ўзбекистон Республикаси Ташқи ишлар вазирлиги', order: 500 },
  { id: 15, title: 'Ўзбекистон Республикаси Адлия вазирлиги', order: 500 },
  { id: 16, title: 'Ўзбекистон Республикаси Ташқи савдо вазирлиги', order: 500 },
  {
    id: 17,
    title:
      ' Ўзбекистон Республикаси Ахборот технологиялари ва коммуникацияларини ривожлантириш вазирлиги',
    order: 500,
  },
];

export const details = {
  id: 3,
  title: 'Ўзбекистон Республикаси Молия вазирлиги',
  address: '100008, Тошкент шаҳри, Мустақиллик майдони, 5',
  website: 'www.mf.uz',
  email: 'info@mf.uz',
  fax: '0(371) 244-5643',
  category_id: 1,
  cabinetpm_org_id: 1,
  category_title: 'Вазирликлар',
  category_class: 'ministries',
  functions: '',
  tasks: '<ul><li>Bibibib</li></ul>',
  guid: '9feb4506-b7d4-ce82-29cc-2efe0b17303d',
};

export const detailsInfo = {
  category_id: 16,
  authority_id: 6398,
  title:
    'Ўзбекистон Республикаси Энергетика вазирлиги ҳузуридаги Электр энергияси, нефт маҳсулотлари ва газдан фойдаланишни назорат қилиш инспекцияси',
  address: '100047, Ташкент ш., Истикбол кўчаси, 21',
  functions:
    '<ul><li>юридик ва жисмоний шахслар\r\nтомонидан (аҳолидан ташқари) ёқилғи-энергия ресурсларини ишлаб чиқариш (қазиб\r\nолиш), қайта ишлаш, узатиш (ташиш), тақсимлаш ва истеъмол қилиш, уларнинг сифат\r\nва миқдор жиҳатидан сақланишини таъминлаш соҳасидаги қонунчилик ҳужжатлари\r\nҳамда техник жиҳатдан тартибга солиш бўйича норматив ҳужжатлар талабларига риоя\r\nқилиниши устидан давлат назоратини амалга ошириш;</li><li>юридик ва жисмоний шахслар\r\nтомонидан (аҳолидан ташқари) электр, газ узатиш ва газ тақсимлаш тармоқларига\r\nноқонуний уланиш, ёқилғи-энергия ресурсларини талон-тарож қилиш ва ноқонуний\r\nистеъмол қилишнинг бошқа ҳолатларини, шунингдек, уларни содир этишга имкон\r\nберувчи сабаб ва шарт-шароитларни аниқлаш, бартараф этиш ва олдини олиш;</li><li>бевосита истеъмолчилар\r\nтомонидан фойдаланилган ҳамда тегишли ҳудудлар чегарасидаги тармоқларга етказиб\r\nберилган ёқилғи-энергия ресурслари ҳажми ўртасидаги тафовутларни аниқлаш ва\r\nбартараф этиш;</li><li>юридик ва жисмоний шахслар\r\nтомонидан (аҳолидан ташқари) энергетика обектларида бахтсиз ҳодисалар ва\r\nтехнологик бузилишлар (авариялар)нинг олдини олиш чора-тадбирлари ишлаб\r\nчиқилиши ва унинг бажарилиши устидан назоратни амалга ошириш;</li><li>қайта тикланувчи энергия\r\nманбалари қурилмаларини ҳамда энергия самарадор ва энергия тежовчи замонавий\r\nтехнологияларни жорий қилиш, шунингдек, энергия ресурсларини истеъмол қилиш\r\nсамарадорлигининг мониторингини олиб бориш;</li><li>ёқилғи-энергия ресурсларидан\r\nоқилона ва самарали фойдаланишни таъминлаш бўйича истеъмолчилар (аҳолидан\r\nташқари) томонидан бажариладиган чора-тадбирларнинг энергия самарадорлигини\r\nбаҳолаш, шунингдек, маҳсулот бирлигини ишлаб чиқариш (иш бажариш, хизмат\r\nкўрсатиш) учун ёқилғи-энергия ресурслари истеъмолининг меъёрлари бажарилиши ва\r\nкелгусида такомиллаштирилиши устидан назоратни амалга ошириш</li>\r\n</ul><p><o:p></o:p></p><p><o:p></o:p></p><p><o:p></o:p></p><p><o:p></o:p></p>',
  tasks: '',
  fax: '0 (371)  236-79-73',
  phone: '(03) 712-33-99',
  website: 'www.uzngi.uz',
  email: 'info@uzngi.uz',
  is_creator_request: true,
  parent_id: 12217,
  heads: [
    {
      id: 738,
      authority_id: 6398,
      head_title: 'Агзамов Нодир Тахирович',
      head_order: 10,
      head_position: 'Бошлиқ',
      head_phone: '(71) 233-99-96',
      reception_days: 'Душанба',
      reception_time: '09:00 - 18:00',
      email: 'info@uzngi.uz',
      linkAuthorityHeadsReceptionDays: [
        {
          id: 1654,
          authority_head_id: 738,
          reception_day: 'Душанба',
          reception_time_from: '09:00:00',
          reception_time_to: '18:00:00',
        },
      ],
    },
    {
      id: 5342,
      authority_id: 6398,
      head_title: 'Эгамбердиев Умаржон Усманалиевич',
      head_order: 10,
      head_position: 'Бошлиқ',
      head_phone: '(71) 200-02-86',
      reception_days: null,
      reception_time: null,
      email: 'evuzenergoinspeksiya@umail.uz',
      linkAuthorityHeadsReceptionDays: [],
    },
    {
      id: 5344,
      authority_id: 6398,
      head_title: 'Эгамбердиев Умаржон Усманалиевич',
      head_order: 10,
      head_position: 'Бошлиқ',
      head_phone: '(71) 200-02-86',
      reception_days: null,
      reception_time: null,
      email: 'evuzenergoinspeksiya@umail.uz',
      linkAuthorityHeadsReceptionDays: [],
    },
    {
      id: 5348,
      authority_id: 6398,
      head_title: 'Эгамбердиев Умаржон Усманалиевич',
      head_order: 10,
      head_position: 'Бошлиқ',
      head_phone: '(71) 200-02-86',
      reception_days: null,
      reception_time: null,
      email: 'evuzenergoinspeksiya@umail.uz',
      linkAuthorityHeadsReceptionDays: [],
    },
    {
      id: 5343,
      authority_id: 6398,
      head_title: 'Эгамбердиев Умаржон Усманалиевич',
      head_order: 10,
      head_position: 'Бошлиқ',
      head_phone: '(71) 200-02-86',
      reception_days: null,
      reception_time: null,
      email: 'evuzenergoinspeksiya@umail.uz',
      linkAuthorityHeadsReceptionDays: [],
    },
    {
      id: 5345,
      authority_id: 6398,
      head_title: 'Эгамбердиев Умаржон Усманалиевич',
      head_order: 10,
      head_position: 'Бошлиқ',
      head_phone: '(71) 200-02-86',
      reception_days: null,
      reception_time: null,
      email: 'evuzenergoinspeksiya@umail.uz',
      linkAuthorityHeadsReceptionDays: [],
    },
    {
      id: 5346,
      authority_id: 6398,
      head_title: 'Эгамбердиев Умаржон Усманалиевич',
      head_order: 10,
      head_position: 'Бошлиқ',
      head_phone: '(71) 200-02-86',
      reception_days: null,
      reception_time: null,
      email: 'evuzenergoinspeksiya@umail.uz',
      linkAuthorityHeadsReceptionDays: [],
    },
    {
      id: 5347,
      authority_id: 6398,
      head_title: 'Эгамбердиев Умаржон Усманалиевич',
      head_order: 10,
      head_position: 'Бошлиқ',
      head_phone: '(71) 200-02-86',
      reception_days: null,
      reception_time: null,
      email: 'evuzenergoinspeksiya@umail.uz',
      linkAuthorityHeadsReceptionDays: [],
    },
    {
      id: 45,
      authority_id: 6398,
      head_title: 'Исаков Аскар Шарифжон ўғли',
      head_order: 20,
      head_position: 'Бошлиқ ўринбосари',
      head_phone: '(71) 233-99-96',
      reception_days: 'Душанба',
      reception_time: '09:00 - 18:00',
      email: 'info@uzngi.uz',
      linkAuthorityHeadsReceptionDays: [
        {
          id: 1655,
          authority_head_id: 45,
          reception_day: 'Душанба',
          reception_time_from: '09:00:00',
          reception_time_to: '18:00:00',
        },
      ],
    },
  ],
};

export const searchResults = [
  {
    id: 3,
    title: 'Андижон вилояти ҳокимлиги',
    category_id: 1,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 89,
    title: 'Бухоро вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 90,
    title: 'Жиззах вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 91,
    title: 'Қашқадарё вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 93,
    title: 'Навоий вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 95,
    title: 'Наманган вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 96,
    title: 'Самарқанд вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 97,
    title: 'Сурхондарё вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 98,
    title: 'Сирдарё вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 99,
    title: 'Тошкент вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 100,
    title: 'Фарғона вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 101,
    title: 'Хоразм вилояти ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
  {
    id: 102,
    title: 'Тошкент шаҳар ҳокимлиги',
    category_id: 8,
    category_title: 'Маҳаллий давлат ҳокимияти органлари',
    category_class: 'local-administrations',
  },
];

export const fileUploader = `
<div id="user_file_org" class="btn btn-primary waves-effect waves-light"> <i class="icon-file icon-white"></i> Файлни юкланг</div>
        <div class="file-path-wrapper">
            <input readonly="" id="filename" class="file-path" type="text" placeholder="ҳажми  5мб гача">
        </div>
        <div class="clearfix"></div>
        <div class="dropZone fileUploaderFilesListBox">
            <ul id="user_file_orgFilesList" class="fileUploaderFilesList">

            </ul>
            <div class="clearfix"></div>

             <div class="dropArea">
                <div class="dropZoneTextArea">
                    <p>Перетащите файлы сюда</p>
                </div>
            </div>
        </div>
`;



// WEBPACK FOOTER //
// ./src/apps/authorities/fake-api/data.js